







  import {Vue, Component} from "vue-property-decorator";

  import HelloWorld from '@/components/HelloWorld.vue'
  import BotPractices from '@/components/BotPractices.vue'
  import {State} from "vuex-class";
  import {UserInterface} from "@/models/User";


@Component({
  components: {
    HelloWorld, BotPractices
  }
})
export default class Home extends Vue {
     @State(state => state.auth.fullUser) fullUser: UserInterface;

}
